import { ChevronDown } from "lucide-react";
import { useNavigate } from "react-router-dom";

const BADGE_URLS = {
  gold: "https://customer-assets.emergentagent.com/job_travel-quality-label/artifacts/3qf4e4f0_Black%20And%20White%20Simple%20Icon%20Logo.png",
  silver: "https://customer-assets.emergentagent.com/job_travel-quality-label/artifacts/80ndwcjh_Black%20And%20White%20Simple%20Icon%20Logo%20%281%29.png",
  bronze: "https://customer-assets.emergentagent.com/job_travel-quality-label/artifacts/o5vrg8qt_Black%20And%20White%20Simple%20Icon%20Logo%20%282%29.png"
};

const HERO_IMAGE = "https://images.unsplash.com/photo-1540541338287-41700207dee6?w=2400&q=85&auto=format&fit=crop";

const HeroSection = ({ stats }) => {
  const navigate = useNavigate();

  const goToCertifications = () => {
    navigate("/methodology");
    setTimeout(() => {
      const el = document.querySelector("#certification-levels");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 120);
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center pt-20"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${HERO_IMAGE})` }}
      >
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        {/* Quality Badges */}
        <div className="flex justify-center items-center gap-6 mb-8 animate-fade-in-up">
          <img src={BADGE_URLS.gold} alt="Gold Quality Badge" className="w-20 h-20 sm:w-24 sm:h-24 object-contain" />
          <img src={BADGE_URLS.silver} alt="Silver Quality Badge" className="w-16 h-16 sm:w-20 sm:h-20 object-contain" />
          <img src={BADGE_URLS.bronze} alt="Bronze Quality Badge" className="w-14 h-14 sm:w-16 sm:h-16 object-contain" />
        </div>

        {/* Overline */}
        <p className="text-[#D4AF37] text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold mb-6 animate-fade-in-up animation-delay-100">
          World Travel & Tourism Quality
        </p>

        {/* Main Heading */}
        <h1 
          className="font-heading text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-6 tracking-tighter animate-fade-in-up animation-delay-200"
          data-testid="hero-title"
        >
          The Global Standard for
          <br />
          <span className="text-[#D4AF37]">Tourism Excellence</span>
        </h1>

        {/* Subheading */}
        <p 
          className="text-white/90 text-base sm:text-lg max-w-2xl mx-auto mb-6 leading-relaxed animate-fade-in-up animation-delay-300"
          data-testid="hero-subtitle"
        >
          The WTTQ.org Global Hospitality Certification recognizes hospitality 
          businesses that have been independently assessed and verified as meeting 
          internationally recognized standards of excellence in quality, professionalism, 
          and guest experience.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16 animate-fade-in-up animation-delay-400">
          <button
            onClick={goToCertifications}
            className="w-full sm:w-auto bg-[#D4AF37] text-[#0B132B] px-8 py-4 font-semibold tracking-wide hover:bg-[#E8D38E] transition-colors duration-300"
            data-testid="hero-explore-button"
          >
            Explore WTTQ Certifications
          </button>
          <a
            href="#apply"
            className="w-full sm:w-auto border-2 border-white text-white px-8 py-4 font-semibold tracking-wide hover:bg-white/10 transition-colors duration-300 text-center"
            data-testid="hero-apply-button"
          >
            Apply for Certification
          </a>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <ChevronDown className="w-8 h-8 text-white/60" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
